import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import reactStyleable from 'react-styleable';
import Isvg from 'react-inlinesvg';

import WarningIcon from './assets/warning-icon.svg';
import CloseIcon from './assets/close-icon.svg';
import css from './toast.scss';

const Toast = ({
    message,
    icon = WarningIcon,
    variant = 'error',
    showToast = false,
    onClose,
    duration = 5000,
    showCloseButton = false
}) => {
    useEffect(() => {
        if (!showToast) return undefined;

        const id = setTimeout(onClose, duration);
        return () => clearTimeout(id);
    }, [showToast, duration, onClose]);

    if (!showToast) return null;

    return (
        <div className={css.container}>
            <div className={`${css.toast} ${css[variant]}`}>
                <Isvg src={icon} width={'32px'} height={'32px'} display={'flex'} />
                <div className={css.message}>{message}</div>
                <div
                    onClick={onClose}
                    role="button"
                    tabIndex={0}
                    className={css.close}
                >
                    {showCloseButton && <Isvg src={CloseIcon} width={'20px'} height={'20px'} />}
                </div>
            </div>
        </div>
    );
};

Toast.propTypes = {
    showCloseButton: PropTypes.bool,
    message: PropTypes.string,
    icon: PropTypes.string,
    variant: PropTypes.oneOf(['success', 'error']),
    showToast: PropTypes.bool,
    onClose: PropTypes.func,
    duration: PropTypes.number
};

Toast.defaultProps = {
    onClose: () => {}
};

export default reactStyleable(css)(Toast);



// WEBPACK FOOTER //
// ./components/toast/toast.js